export const EVENTS = {
  POINTER_MOVE: 'pointermove',
  POINTER_UP: 'pointerup',
  POINTER_DOWN: 'pointerdown',
  POINTER_CANCEL: 'pointercancel',
  POINTER_LEAVE: 'pointerleave',
  WHEEL: 'wheel',
  GESTURE_CHANGE: 'gesturechange',
  GESTURE_END: 'gestureend',
  GESTURE_START: 'gesturestart',
  KEYDOWN: 'keydown',
  FOCUS_IN: 'focusin'
}
